/**
 * Hidden / auto-provisioned facilities should never appear in the normal
 * facility pickers across the app.
 *
 * Backend convention (SharedLiving SL-070 / Day Program):
 *   - AtHome facilities use an external id starting with "-7<group_id>"
 *   - Day Program facilities use an external id starting with "-9<group_id>"
 *
 * A facility option may carry the external id under a few different keys
 * depending on where it was loaded from, so we check all of them.
 */
const HIDDEN_PREFIXES = ['-7', '-9'];

export const getExternalFacilityId = facility => {
  if (facility == null) return '';

  const raw =
    facility.external_facility_id ??
    facility.externalFacilityId ??
    facility.external_id ??
    facility.externalId ??
    '';

  return String(raw);
};

/**
 * Returns true when a facility is an internal/hidden facility that should be
 * filtered out of facility lists shown to users.
 */
const isHiddenFacility = facility => {
  const externalId = getExternalFacilityId(facility);
  if (!externalId) return false;

  return HIDDEN_PREFIXES.some(prefix => externalId.startsWith(prefix));
};

export default isHiddenFacility;
